import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelpRequest } from '../_models/helpRequest';
import { Mail } from '../_models/mail';
import { MailDetail } from '../_models/mailDetail';
import { MailStatus } from '../_models/mailStatus';
import { UserMail } from '../_models/userMail';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MailService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getListMails() {
    return this.http.get<UserMail[]>(`${environment.apiUrl}/system/mailRecipentList`, { headers: this.authService.headers });
  }

  getSentMails() {
    return this.http.get<MailStatus>(`${environment.apiUrl}/system/mail`, { headers: this.authService.headers });
  }

  getSentMail(id: string) {
    return this.http.get<MailDetail>(`${environment.apiUrl}/system/mail/${id}`, { headers: this.authService.headers });
  }

  sendMail(userId?: string, templateName?: string, resetPassowrd?: boolean): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/system/mail?userid=${userId}&templatename=${templateName}&resetPassowrd=${resetPassowrd}`, { headers: this.authService.headers });
  }

  sendMailReset(login: string): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/system/mailReset?userLogin=${login}`, { headers: this.authService.headers });
  }

  sendMailToTable(newMail: Mail): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/system/mailtotable`, newMail, { headers: this.authService.headers });
  }

  sendHelpRequest(request: HelpRequest): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/system/help`, request, { headers: this.authService.headers });
  }
}
